(() => {
  'use strict';

  const script = document.currentScript;
  const sectionId = script && script.dataset ? script.dataset.sectionId : '';
  if (!sectionId) return;

  const escapedSectionId = window.CSS && CSS.escape ? CSS.escape(sectionId) : sectionId;
  const formSelector = `#ProductForm-${escapedSectionId}`;
  const buttonSelector = `#ProductSubmitButton-${escapedSectionId}`;
  const candidateSelectors = [
    '.swym-button',
    '.swym-add-to-wishlist',
    '.wishlist-hero-custom-button',
    '#wishlist-hero-product-page-button button',
    '.wk-button',
    '.ssw-fave-btn',
    '.hulk-wishlist-btn',
    '.hulk_wl_button',
    '.iWishAdd',
    '.st-wishlist-button',
    '[data-wishlist-button]',
    'button[data-action*="wishlist" i]',
    'a[data-action*="wishlist" i]',
    'button[aria-label*="wishlist" i]',
    'a[aria-label*="wishlist" i]',
    'button[title*="wishlist" i]',
    'a[title*="wishlist" i]',
    'button[class*="wishlist" i]',
    'a[class*="wishlist" i]',
    'button[class*="wish-list" i]',
    'a[class*="wish-list" i]',
    'button[class*="favourite" i]',
    'a[class*="favourite" i]',
    'button[class*="favorite" i]',
    'a[class*="favorite" i]'
  ];

  const excludedAncestorSelector = [
    'header',
    'footer',
    'cart-drawer',
    '.cart-drawer',
    '.card-wrapper',
    '.product-card-wrapper',
    '.quick-add-modal',
    '.related-products',
    '[id*="related-products" i]'
  ].join(',');

  const isVisible = (element) => {
    if (!element || !element.isConnected) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const isWishlistElement = (element) => {
    if (!element || !(element instanceof Element)) return false;
    const text = [
      typeof element.className === 'string' ? element.className : '',
      element.id,
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('data-action')
    ].filter(Boolean).join(' ').toLowerCase();
    return /wish\s*-?\s*list|favourite|favorite|swym|iwish|fave/.test(text);
  };

  const getCandidates = () => {
    const result = new Set();

    candidateSelectors.forEach((selector) => {
      try {
        document.querySelectorAll(selector).forEach((element) => result.add(element));
      } catch (error) {
        // Ignore third-party selector parsing issues.
      }
    });

    try {
      document.querySelectorAll('[id*="wishlist" i], [class*="wishlist" i], [class*="wish-list" i]').forEach((container) => {
        if (container.matches('button, a')) {
          result.add(container);
          return;
        }
        const interactive = container.querySelector('button, a');
        if (interactive) result.add(interactive);
      });
    } catch (error) {
      // Ignore older-browser selector parsing issues.
    }

    return Array.from(result);
  };

  const candidateScore = (candidate, productForm, atcButton) => {
    const rect = candidate.getBoundingClientRect();
    const atcRect = atcButton.getBoundingClientRect();
    let score = Math.abs(rect.top - atcRect.top) + Math.abs(rect.left - atcRect.right);

    if (productForm.contains(candidate)) score -= 10000;
    if (candidate.closest('main-product, .product, .product__info-container, .product-info')) score -= 2000;
    if (candidate.closest(excludedAncestorSelector)) score += 50000;
    if (!isVisible(candidate)) score += 20000;
    if (!isWishlistElement(candidate)) score += 10000;

    return score;
  };

  const findWishlistButton = (productForm, atcButton) => {
    const nativeForm = productForm.querySelector('form');

    return getCandidates()
      .filter((candidate) => {
        if (!isVisible(candidate) || !isWishlistElement(candidate)) return false;
        if (candidate.closest(excludedAncestorSelector)) return false;
        if (candidate === atcButton || candidate.contains(atcButton)) return false;

        const ownerForm = candidate.closest('form');
        if (ownerForm && ownerForm !== nativeForm) return false;

        return true;
      })
      .sort((a, b) => candidateScore(a, productForm, atcButton) - candidateScore(b, productForm, atcButton))[0] || null;
  };

  const applyLayout = () => {
    const productForm = document.querySelector(formSelector);
    const atcButton = document.querySelector(buttonSelector);
    const row = productForm && productForm.querySelector('.product-form__quantity-and-btn');
    if (!productForm || !atcButton || !row) return false;

    row.classList.add('shrine-atc-wishlist-row');

    const existing = row.querySelector('.shrine-atc-wishlist-item');
    if (existing) return true;

    const wishlistButton = findWishlistButton(productForm, atcButton);
    if (!wishlistButton) return false;

    if (wishlistButton.tagName === 'BUTTON' && !wishlistButton.getAttribute('type')) {
      wishlistButton.setAttribute('type', 'button');
    }

    wishlistButton.classList.add('shrine-atc-wishlist-item');
    if (!wishlistButton.querySelector('svg, img, .icon, [class*="icon" i]')) {
      wishlistButton.classList.add('shrine-atc-wishlist-item--text-only');
    }

    row.appendChild(wishlistButton);
    return true;
  };

  const start = () => {
    applyLayout();

    const observer = new MutationObserver(() => {
      if (applyLayout()) observer.disconnect();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(() => observer.disconnect(), 20000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
